<template>
  <div class="role-wrap">
    <div class="header-title">角色管理</div>
    <div class="flex">
      <div class="filter flex">
        <el-input
          v-model="search"
          style="width: 300px"
          placeholder="输入角色代码/角色名称搜索"
        />
        <el-button style="margin-left: 16px" @click="resetFilter"
          >重置</el-button
        >
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>
      <el-button type="primary" @click="addRole">添加角色</el-button>
    </div>
    <el-table
      :data="list"
      style="width: 100%"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      ref="table"
      :height="tableHeight"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" class="demo-table-expand">
            <el-form-item label="角色权限">
              <span>{{ props.row.permStr }}</span>
            </el-form-item>
            <el-form-item label="权限明细">
              <span>{{ props.row.permCode }}</span>
            </el-form-item>
            <el-form-item label="URL">
              <span>{{ props.row.urls }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="id" prop="id"></el-table-column>
      <el-table-column label="角色代码 " prop="roleCode"></el-table-column>
      <el-table-column label="角色名称" prop="roleName"></el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <el-button type="text" @click="handleChannelPerm(scope.row)"
            >基础配置权限
          </el-button>
          <el-button type="text" @click="handleRole(scope.row)"
            >权限管理
          </el-button>
          <el-button
            type="text"
            @click="editRole(scope.row)"
            v-if="!scope.row.otherSysRole"
            >编辑</el-button
          >
          <el-button
            v-if="!scope.row.otherSysRole"
            type="text"
            @click="deleteRole(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <self-pagination
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      @getCurrentPage="changePage"
      @handleSizeChange="handleSizeChange"
    ></self-pagination>
    <perms-transfer-dialog
      :permsRoleList="permsRoleList"
      :selePermValue="selePermValue"
      :permdialogVisible="permdialogVisible"
      :search="search"
      :uid="rid"
      flag="perm"
      @closeDialog="closeDialog"
    ></perms-transfer-dialog>
    <channel-perm-modal
      :refType="1"
      ref="channelPermModal"
    ></channel-perm-modal>
    <add-role-modal
      ref="addRoleModalRef"
      @successCallBack="handleSearch"
    ></add-role-modal>
  </div>
</template>
<script>
import { getRoleList, delRole } from "@/api/account-management.js";

export default {
  data() {
    return {
      search: "",
      selectUserValue: [],
      selePermValue: [],
      permdialogVisible: false,
      rid: "",
      productName: "",
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      loading: false,
      tableHeight: window.innerHeight - 260,
      list: [],
    };
  },
  props: {},
  components: {
    ChannelPermModal: () => import("./channelPermModal.vue"),
    AddRoleModal: () => import("./addRoleModal.vue"),
    PermsTransferDialog: () =>
      import("@/pages/account/user-manage/permsTransferDialog"),
  },
  computed: {
    permsRoleList: function () {
      return this.$store.state.RolePower.permsRoleList;
    },
  },
  methods: {
    handleChannelPerm(data) {
      this.$refs.channelPermModal.showModal(data);
    },
    getList() {
      this.loading = true;
      getRoleList({
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        condition: this.search,
      }).then((res) => {
        if (res.code == "0000") {
          this.pageData.total = res.data.roleCount;
          this.list = res.data.pageRoleInfo;
        }
        this.loading = false;
      });
    },
    resetFilter() {
      this.search = "";
      this.pageData.page = 1;
      this.getList();
    },
    handleSearch() {
      this.pageData.page = 1;
      this.getList();
    },
    handleRole(row) {
      this.selePermValue = row.permId == "" ? [] : row.permId.split(",");
      this.permdialogVisible = true;
      this.rid = row.id.toString();
    },
    closeDialog() {
      this.permdialogVisible = false;
    },
    addRole() {
      this.$refs.addRoleModalRef.showModal("add");
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.pageData.size = size;
      this.pageData.page = 1;
      this.getList();
    },
    editRole(data) {
      this.$refs.addRoleModalRef.showModal("edit", data);
    },
    deleteRole(data) {
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          delRole({
            roleId: data.id,
          }).then((res) => {
            if (res.code === "0000") {
              this.$message.success("删除成功");
              this.changePage(1);
            }
            this.loading = false;
          });
        })
        .catch(() => {});
    },
    refresh() {
      this.tableHeight = window.innerHeight - 200;
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
    this.$store.dispatch("getRoleInfoList", {
      param: { currentPage: 1, pageSize: 10 },
      cb: () => {},
    });
    if (this.$route.query.roleName) {
      this.search = this.$route.query.roleName;
      this.$nextTick(() => {
        setTimeout(() => {
          this.getList();
        }, 200);
      });
    } else {
      this.getList();
    }
  },
};
</script>

<style lang="less" scoped>
.role-wrap {
  margin: 16px;
  height: calc(100vh - 125px);
  padding: 16px 24px 16px 24px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .header-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 15px;
    flex: 1;
    margin-bottom: 16px;
  }
  .filter {
    flex: 1;
    margin-bottom: 16px;
    .multiple-select {
      margin-left: 16px;
      width: 220px;
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .table-item {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
